import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import Empty from 'theme/icons/empty';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${themeGet('space.xl')}px 0;
  justify-content: center;
  align-items: center;

  & > p {
    margin-top: ${themeGet('space.xs')}px;
  }
`;

function EmptyData({ label }) {
  return (
    <Wrapper>
      <Empty />
      <p>{label}</p>
    </Wrapper>
  );
}

export default EmptyData;
